import { Component, OnInit, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import * as HighchartsMore from "highcharts/highcharts-more";
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-compare',
  templateUrl: './compare.component.html',
  styleUrls: ['./compare.component.scss']
})
export class CompareComponent implements OnInit {

  constructor(public globalService:GlobalService) { }
  @Input() guageValue: Array<any> = [];
  @Input() legend:any;
  @Input() pageTab: any;
  @Input() data: any;
  @Input() index: any;
  @Input() xvalueSequence:any;
  @Input() graphType:any;
  @Input() GraphTytle:any;
  @Input() kpiScore:any;
  @Input() xValue:any;
  @Input() units:any;
  @Input() typeGraph:any;
  @Input() graphcheck:any;
  // public networkTag:Array<string> = ['0 - 1 ','1 - 2 ','2 - 3 ','3 - 4 ','4 - 5 ','5 - 6 ','6 - 7 ','7 - 8 ','> 8 '];
  ngOnInit() { }
  ngAfterViewInit() {
    setTimeout(() => {
      let obj = {
        pagetab: this.pageTab,
        index: this.index,
        graphType:this.graphType
      };
      this.assignToGraph(obj);
    }, 0);

  }
  assignToGraph({ pagetab, index,graphType }) {
    if(graphType=='clustered'){
      var json = this.guageValue;
      var finalJSON = [];
      var maxArrLen = 0;
      var drawVal = [];
      // var Max_number;
      var colorFlag=false;
      var color = ['#044BEC','#24CCB8','#FFC400','#f8e7a8','#F08080','#c9ede7','#FFE4B5','#FFE4E1'];
      var copyObj='';
      for (var jListIndex = 0; jListIndex < json.length; jListIndex++) {
       copyObj = json[jListIndex];
       drawVal.push({name: copyObj['name'],color:color[jListIndex],data: []});
       if (maxArrLen < json[jListIndex].value.length) {
        maxArrLen = json[jListIndex].value.length;
      }

    }
    if(maxArrLen){
      for (var jListIndex = 0; jListIndex < json.length; jListIndex++) {
        copyObj = json[jListIndex];
        for (var jValueInd = 0; jValueInd < maxArrLen; jValueInd++) {
          if (copyObj['value'][jValueInd]) {
            if(this.xValue==='networktag'){
              copyObj['value'][jValueInd]["_id"]['xValue'] =  copyObj['value'][jValueInd]["_id"]['xValue'].substring(0,copyObj['value'][jValueInd]["_id"]['xValue'].lastIndexOf(" ") + 1);
              if (finalJSON.indexOf(copyObj['value'][jValueInd]["_id"]['xValue']) < 0) {
                finalJSON.push(copyObj['value'][jValueInd]["_id"]['xValue']);
              }   
          }else{
            if (finalJSON.indexOf(copyObj['value'][jValueInd]["_id"]['xValue']) < 0) {
              finalJSON.push(copyObj['value'][jValueInd]["_id"]['xValue']);
            }
          }
          }
          drawVal[jListIndex]['data'][jValueInd] = ' ';
        }
      }
      let custrom_sort=[];
      let getValToCheck = [];
      for(let obj of this.xvalueSequence){
        if(Object.keys(obj)[0]==this.xValue){
          getValToCheck.push(obj[this.xValue]);  
        }
         }
         for(var i=0;i<getValToCheck[0].length;i++){ 
           if(this.xValue=='networktag'){
           getValToCheck[0][i]=getValToCheck[0][i].substring(0,getValToCheck[0][i].lastIndexOf(" ") + 1);
           }else{
            getValToCheck[0][i]=getValToCheck[0][i];
           }
           for(var j=0;j<finalJSON.length;j++){
             if(getValToCheck[0][i]==finalJSON[j])
               custrom_sort.push(getValToCheck[0][i]);
          }
         }
         finalJSON = [];
         finalJSON = [...custrom_sort];
        
      for (var jListIndex = 0; jListIndex < json.length; jListIndex++) {
        copyObj = json[jListIndex];
        for (var jValueInd = 0; jValueInd < copyObj['value'].length; jValueInd++) {
         if(this.xValue=='networktag'){
          copyObj['value'][jValueInd]["_id"]['xValue'] =  copyObj['value'][jValueInd]["_id"]['xValue'].substring(0,copyObj['value'][jValueInd]["_id"]['xValue'].lastIndexOf(" ") + 1);

          var ind = finalJSON.indexOf(copyObj['value'][jValueInd]["_id"]['xValue']);
          drawVal[jListIndex]['data'][ind] = +(copyObj['value'][jValueInd][copyObj['value'][jValueInd]['scoreName']].toFixed(1));  
      }else{
        var ind = finalJSON.indexOf(copyObj['value'][jValueInd]["_id"]['xValue']);
        drawVal[jListIndex]['data'][ind] = +(copyObj['value'][jValueInd][copyObj['value'][jValueInd]['scoreName']].toFixed(1));
      }

        
        }
      }
      
//      var allMax=[];
// for(var i=0;i<drawVal.length;i++){
// var data = drawVal[i]['data'];
//     allMax.push(Math.max(...data));
// }
// Max_number = Math.ceil(Math.max(...allMax)); 
    }
  }else{
    if(this.graphcheck==='benchmarking'){
    
      var finalJSON = [];
      var drawVal = [];
      // var Max_number;
      var color = ['#044BEC','#24CCB8','#FFC400','orange','green'];
      for (let j = 0; j < this.guageValue.length; j++) {
        if(this.xValue==='networktag'){
          this.guageValue[j]._id =  this.guageValue[j]._id.substring(0,this.guageValue[j]._id.lastIndexOf(" ") + 1);
          drawVal.push({y:this.guageValue[j][this.guageValue[j].scoreName]?+(this.guageValue[j][this.guageValue[j].scoreName].toFixed(1)):+(this.guageValue[j][this.data['scoreName']].toFixed(1)),color:color[j]});
          finalJSON.push(this.guageValue[j]._id);   
      }else{
        drawVal.push({y:this.guageValue[j][this.guageValue[j].scoreName]?+(this.guageValue[j][this.guageValue[j].scoreName].toFixed(1)):+(this.guageValue[j][this.data['scoreName']].toFixed(1)),color:color[j]});
        finalJSON.push(this.guageValue[j]._id);
      }
  
      }
//       var allMax=[];
// for(var i=0;i<drawVal.length;i++){
// var data = drawVal[i]['y'];
//     allMax.push(data);
// }
// Max_number = Math.ceil(Math.max(...allMax));
    }else{
      var finalJSON = [];
      var drawVal = [];
      // var Max_number;
      for (let j = 0; j < this.guageValue.length; j++) {
        if(this.xValue==='networktag'){
          this.guageValue[j]._id =  this.guageValue[j]._id.substring(0,this.guageValue[j]._id.lastIndexOf(" ") + 1);
          drawVal.push(this.guageValue[j][this.guageValue[j].scoreName]?+(this.guageValue[j][this.guageValue[j].scoreName].toFixed(1)):+(this.guageValue[j][this.data['scoreName']].toFixed(1)));
          finalJSON.push(this.guageValue[j]._id);   
      }else{
        drawVal.push(this.guageValue[j][this.guageValue[j].scoreName]?+(this.guageValue[j][this.guageValue[j].scoreName].toFixed(1)):+(this.guageValue[j][this.data['scoreName']].toFixed(1)));
        finalJSON.push(this.guageValue[j]._id);
      }
     
      }
      // Max_number = Math.ceil(Math.max(...drawVal));
    }

    colorFlag=false;
    
    drawVal = [{data:drawVal}];
    
  }

    //  for(let k=0;k<document.getElementsByClassName(`graph${pagetab} graphs${index}`).length;k++){
    //  let a:any = document.getElementsByClassName(`graph${pagetab} graphs${index}`)[k];
    //  let a:any = document.getElementsByClassName('bar-charts')[index];
    let a: any = document.getElementById('bargraph' + this.pageTab + this.index);
    if (a) {
      let _this=this;
      Highcharts.chart(a, {
        chart: {
          type: 'column',
        },
        title: {
            text: this.GraphTytle
          },
        subtitle: {
          text: ''
        },
        xAxis: {
          categories:finalJSON,
          crosshair: true,
          labels: {
                        enabled: true,
                        rotation: 0,
                        formatter: function ():any {
                            let str:any= this.value.toString();
                            if(_this.xValue=='networktag'){
                              return '<span style="color:#666666;" title="' + this.value + '">' + str+ '</span>';
                            }else{
                            if(finalJSON.length>3){
                            return '<span style="color:#666666;" title="' + this.value + '">' + str.substr(0,8)+(str.length>8?'..':'')+ '</span>';
            
                                      }else{
                    return '<span style="color:#666666;" title="' + this.value + '">' + str+ '</span>';

                                      }
                                                  }},
            useHTML: true,
          },
          min: 0,
          title: {
            text:this.xValue==undefined?this.globalService.orderType
            :((this.xValue && this.xValue.toLowerCase())==='networktag')?this.xValue+' '+'(Mbps)':this.xValue,
          },
        },
        yAxis: {
          allowDecimals: false,
          min: 0,
          // max:Max_number,
          title: {
            text: this.kpiScore ? this.kpiScore + '('+(this.typeGraph?'Metric':'Index')+')' : null,
          },
          labels: {
            enabled: true,
            rotation: 0,
            formatter: function ():any {
                let str:any= this.value.toString();
                 return _this.typeGraph?str+' '+_this.units[_this.kpiScore]:str
                },
    useHTML: true,
},
        },

        plotOptions: {
          column: {
            pointPadding: 0,
            borderRadius: 5,
            borderWidth: 2,
            groupPadding:0.15,
            shadow: false,
            colorByPoint:colorFlag,
            dataLabels: {
              enabled: true,
              overflow: 'allow',
              crop: false,
              formatter: function() {
                return this.y > 0 ? this.y : null;
            },
              align:'center',
              color: 'black',
              inside:false,
            },
            
          },
        },
        series:drawVal
      });
    }
  }
  //  }
  ngDoCheck(){
    if(this.graphcheck==='monitoring' ||this.graphType !='clustered'){
    let element: any = document.getElementById('bargraph' + this.pageTab + this.index);
    if (element) {
      let credits: any = element.getElementsByClassName('highcharts-credits') ? element.getElementsByClassName('highcharts-credits')[0] : '';
      if (credits) {
        credits.style.display="none";
      }
      let legend: any = element.getElementsByClassName('highcharts-legend-item') ? element.getElementsByClassName('highcharts-legend-item')[0] : '';
      if (legend) {
        legend.style.display="none";
      }
    }
    }
  }
}